import { Outlet } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes.ts';
import { Portal } from '@sorare/core/src/atoms/layout/Portal/index.tsx';
import { ANY_SPORT_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { ArenaLineupsStickyFooter } from '#src/components/arena/ArenaLineupsStickyFooter/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const ArenaLineupsLayout = () => {
  const { fixture, competition } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();

  const composeUrl = generateSportContextPath(
    ANY_SPORT_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD,
    {
      params: {
        eventType: So5FixtureEvent.CLASSIC.toLowerCase(),
        leaderboard: competition,
      },
    }
  );

  return (
    <>
      <Outlet />
      <Portal id="above-bottom-bar-portal">
        <ArenaLineupsStickyFooter
          fixture={fixture}
          competition={competition}
          to={composeUrl}
        />
      </Portal>
    </>
  );
};

export default ArenaLineupsLayout;
